import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import QueryString from "qs";
import { ReqMethods, ghl } from "../../../enums";
import { useAppServices } from "../../../hook/services";
import env from "../../../config";
function GHL() {
  const { appId } = useParams();
  const { search } = useLocation();
  const code = new URLSearchParams(search).get("code");
  const AppServices = useAppServices();
  const [Error, setError] = useState("");

  const associate = async (company, creds, app, location) => {
    const payload = {
      companyName: company?.name,
      locationName: location?.name,
      userId: creds.userId,
      userType: creds.userType,
      locationId: creds.locationId,
      companyId: creds.companyId,
      access_token: creds.access_token,
      refresh_token: creds.refresh_token,
      company: company,
      location: location,
      appId: appId,
      appRefId: app._id,
      appType:app?.appType,
    };

    const { response } = await AppServices.auth.integrate_app({ payload });

    if (!response)
      return setError(
        "Something went wrong while integration, please try latter"
      );

    return setError("App Integrate Successfully");
  };
  const getLocation = async ( creds, app) => {
    const payload = {
      method: ReqMethods.GET,
      path: `${ghl.APIs.v2.location(creds.locationId)}`,
      key: creds.access_token,
      refresh_token: creds.refresh_token,
    };
    // console.log(payload)
    const { response } = await AppServices.services.ghl.call_service({
      payload,
    });

    if (!response)
      return setError(
        "Something went wrong while integration, please try latter"
      );
    // console.log(response.data)
    return response && associate(null, creds, app, response.data.location);
  };

  const getCompany = async (creds, app) => {
    const payload = {
      method: ReqMethods.GET,
      path: `${ghl.APIs.v2.company(creds.companyId)}`,
      key: creds.access_token,
      refresh_token: creds.refresh_token,
    };
    // console.log(payload)
    const { response } = await AppServices.services.ghl.call_service({
      payload,
    });

    if (!response)
      return setError(
        "Something went wrong while integration, please try latter"
      );
    // console.log(response.data)
    return response && associate(response.data.company, creds, app);
  };

  const getCreds = async (app) => {
    const payload = {
      method: ReqMethods.POST,
      path: ghl.APIs.oauth,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      payload: QueryString.stringify({
        client_id: app.clientId,
        client_secret: app.clientSecret,
        grant_type: "authorization_code",
        code,
        refresh_token: "",
      }),
    };
    // console.log(payload)
    const { response } = await AppServices.services.ghl.call_service({
      payload,
    });

    if (!response)
      return setError(
        "Something went wrong while integration, please try latter"
      );

    return response && response.data?.locationId ?
     getLocation(response.data, app) 
     :
     app?.appType=="agency" ?
     getCompany(response.data, app) 
     :
     associate(null, response.data, app);

  };
  const getApp = async () => {
    const { response } = await AppServices.apps.filter({
      query: `appId=${appId}`,
    });
    if (response) {
      return getCreds(response.data);
    }
  };
  let pageLoad=true

  const onLoad = () => {
    if(pageLoad){

      getApp();
      pageLoad=false
    }
  };

  useEffect(onLoad, []);

  return (
    <div>
      {!Error && <div>Integrating please wait...</div>}
      {Error && (
        <div>
          {Error}
          {/* <MDButton onClick={() => navigate(-2)}>Go Back</MDButton> */}
        </div>
      )}
    </div>
  );
}

export default GHL;
